// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-container {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    background: linear-gradient(135deg, #0e0635 0%, #1a0d4d 100%);
}

.home-content {
    max-width: 1200px;
    width: 100%;
    text-align: center;
}

.main-title {
    font-size: 4rem;
    font-weight: 700;
    color: #ffffff;
    margin: 0 0 1rem 0;
    text-transform: uppercase;
    letter-spacing: 2px;
}

.subtitle {
    font-size: 1.5rem;
    font-weight: 400;
    color: #97a7ff;
    margin: 0 0 3rem 0;
}

.cards-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    margin-top: 3rem;
}

.card {
    background: rgba(255, 255, 255, 0.05);
    border: 2px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 2rem;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.card:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: #97a7ff;
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(151, 167, 255, 0.3);
}

.card-icon {
    font-size: 3rem;
    color: #ebae5e;
    margin-bottom: 1rem;
}

.card-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #ffffff;
    margin: 0 0 0.5rem 0;
}

.card-description {
    font-size: 1rem;
    color: #97a7ff;
    margin: 0;
    line-height: 1.5;
}

/* Responsive Styles */
@media (max-width: 992px) {
    .main-title {
        font-size: 3rem;
    }

    .subtitle {
        font-size: 1.25rem;
    }

    .cards-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 1.5rem;
    }

    .card {
        padding: 1.5rem;
    }
}

@media (max-width: 768px) {
    .home-container {
        padding: 1rem;
    }

    .main-title {
        font-size: 2.5rem;
    }

    .subtitle {
        font-size: 1.1rem;
        margin-bottom: 2rem;
    }

    .cards-grid {
        grid-template-columns: 1fr;
        gap: 1rem;
    }

    .card {
        padding: 1.5rem;
    }

    .card-icon {
        font-size: 2.5rem;
    }

    .card-title {
        font-size: 1.25rem;
    }

    .card-description {
        font-size: 0.9rem;
    }
}

@media (max-width: 576px) {
    .main-title {
        font-size: 2rem;
    }

    .subtitle {
        font-size: 1rem;
    }

    .card-icon {
        font-size: 2rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/covfile/Home.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,6DAA6D;AACjE;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;IACrB,2BAA2B;IAC3B,gDAAgD;AACpD;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,qCAAqC;QACrC,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".home-container {\r\n    min-height: 100vh;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 2rem;\r\n    background: linear-gradient(135deg, #0e0635 0%, #1a0d4d 100%);\r\n}\r\n\r\n.home-content {\r\n    max-width: 1200px;\r\n    width: 100%;\r\n    text-align: center;\r\n}\r\n\r\n.main-title {\r\n    font-size: 4rem;\r\n    font-weight: 700;\r\n    color: #ffffff;\r\n    margin: 0 0 1rem 0;\r\n    text-transform: uppercase;\r\n    letter-spacing: 2px;\r\n}\r\n\r\n.subtitle {\r\n    font-size: 1.5rem;\r\n    font-weight: 400;\r\n    color: #97a7ff;\r\n    margin: 0 0 3rem 0;\r\n}\r\n\r\n.cards-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(3, 1fr);\r\n    gap: 2rem;\r\n    margin-top: 3rem;\r\n}\r\n\r\n.card {\r\n    background: rgba(255, 255, 255, 0.05);\r\n    border: 2px solid rgba(255, 255, 255, 0.1);\r\n    border-radius: 12px;\r\n    padding: 2rem;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    text-align: center;\r\n}\r\n\r\n.card:hover {\r\n    background: rgba(255, 255, 255, 0.1);\r\n    border-color: #97a7ff;\r\n    transform: translateY(-5px);\r\n    box-shadow: 0 10px 30px rgba(151, 167, 255, 0.3);\r\n}\r\n\r\n.card-icon {\r\n    font-size: 3rem;\r\n    color: #ebae5e;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.card-title {\r\n    font-size: 1.5rem;\r\n    font-weight: 600;\r\n    color: #ffffff;\r\n    margin: 0 0 0.5rem 0;\r\n}\r\n\r\n.card-description {\r\n    font-size: 1rem;\r\n    color: #97a7ff;\r\n    margin: 0;\r\n    line-height: 1.5;\r\n}\r\n\r\n/* Responsive Styles */\r\n@media (max-width: 992px) {\r\n    .main-title {\r\n        font-size: 3rem;\r\n    }\r\n\r\n    .subtitle {\r\n        font-size: 1.25rem;\r\n    }\r\n\r\n    .cards-grid {\r\n        grid-template-columns: repeat(2, 1fr);\r\n        gap: 1.5rem;\r\n    }\r\n\r\n    .card {\r\n        padding: 1.5rem;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .home-container {\r\n        padding: 1rem;\r\n    }\r\n\r\n    .main-title {\r\n        font-size: 2.5rem;\r\n    }\r\n\r\n    .subtitle {\r\n        font-size: 1.1rem;\r\n        margin-bottom: 2rem;\r\n    }\r\n\r\n    .cards-grid {\r\n        grid-template-columns: 1fr;\r\n        gap: 1rem;\r\n    }\r\n\r\n    .card {\r\n        padding: 1.5rem;\r\n    }\r\n\r\n    .card-icon {\r\n        font-size: 2.5rem;\r\n    }\r\n\r\n    .card-title {\r\n        font-size: 1.25rem;\r\n    }\r\n\r\n    .card-description {\r\n        font-size: 0.9rem;\r\n    }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n    .main-title {\r\n        font-size: 2rem;\r\n    }\r\n\r\n    .subtitle {\r\n        font-size: 1rem;\r\n    }\r\n\r\n    .card-icon {\r\n        font-size: 2rem;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
